import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK = {
  mothers_supported: 2400,
  children_reached: 3100,
  scholarships_awarded: 180,
  communities_served: 24,
};

const ITEMS = [
  { key: "mothers_supported", label: "Mothers walking with us", suffix: "+" },
  { key: "children_reached", label: "Children reached", suffix: "+" },
  { key: "scholarships_awarded", label: "Scholarships awarded", suffix: "" },
  { key: "communities_served", label: "Communities served", suffix: "" },
];

export default function Impact() {
  const [stats, setStats] = useState(FALLBACK);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/stats`)
      .then((r) => mounted && setStats({ ...FALLBACK, ...r.data }))
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <section
      id="impact"
      data-testid="impact-section"
      className="relative py-20 lg:py-28 bg-brand-navy text-white overflow-hidden"
    >
      <div className="absolute inset-0 grain pointer-events-none" />
      <div className="absolute -top-32 -right-32 h-[420px] w-[420px] rounded-full bg-brand-forest/30 blur-3xl" />
      <div className="absolute -bottom-32 -left-32 h-[420px] w-[420px] rounded-full bg-brand-gold/10 blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 relative">
        <div className="max-w-2xl">
          <div className="text-xs uppercase tracking-[0.22em] text-brand-gold font-semibold">
            Our impact
          </div>
          <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
            Numbers that{" "}
            <span className="italic text-brand-gold">carry names.</span>
          </h2>
          <p className="mt-4 text-white/75 text-lg leading-relaxed">
            Behind every statistic is a mother who reclaimed her future and a
            child who got to keep dreaming.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {ITEMS.map((item, i) => (
            <motion.div
              key={item.key}
              data-testid={`impact-stat-${item.key}`}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="rounded-2xl border border-white/10 bg-white/[0.03] p-6 lg:p-8 backdrop-blur"
            >
              <div className="font-serif text-5xl lg:text-6xl text-brand-gold leading-none">
                {(stats[item.key] ?? 0).toLocaleString()}
                {item.suffix}
              </div>
              <div className="mt-3 text-sm text-white/70">{item.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
